{
  "apply": "Anwenden ({count})",
  "buttonLabel": "Filter",
  "close": "Schließen",
  "deleteSelectedFilter": "Den ausgewählten Filter löschen",
  "header": "Filter",
  "searchByName": "Nach Namen suchen",
  "model": "Modell",
  "type": "Typ",
  "clearFilters": "Filter zurücksetzen",
  "connectivity": "Konnektivität",
  "certificate": "Zertifikat",
  "state": "Status",
  "certificateValidity": {
    "title": "Zertifikatsgültigkeit",
    "expired": "Nur abgelaufen",
    "validityUnder1": "Nur < 1 Monat",
    "validityUnder3": "Nur < 3 Monate",
    "validityUnder6": "Nur < 6 Monate",
    "validityAfter6": "Nur > 6 Monate",
    "label": "Ablaufdatum des Zertifikats"
  },
  "validityInMonth": "Die ausgewählte Gültigkeit ist in Monat",
  "range": "Bereich",
  "creationDate": {
    "label": "Datum",
    "formatter": {
      "input": "YYYY-MM-DD",
      "tag": "YYYY-MM-DD"
    },
    "periodSeparator": "bis",
    "placeholder": "Einen Zeitraum auswählen"
  },
  "selectCreationDate": "Das Datum auswählen",
  "date": {
    "to": "bis",
    "startPlaceholder": "Startdatum",
    "endPlaceholder": "Enddatum",
    "formatter": {
      "tag": "YYYY-MM-DD"
    },
    "periodSeparator": "bis",
    "period": {
      "placeholder": "Einen Zeitraum auswählen",
      "separator": "bis"
    }
  },
  "resetFilter": "Filter zurücksetzen | Filter zurücksetzen",
  "validateFilter": "Filter validieren",
  "searchDevice": "Geräte suchen",
  "sector": "Sektor",
  "searchOperations": "Nach Vorgängen suchen",
  "searchByLastNameOrFirstName": "Nach Nachname oder Vorname suchen",
  "search": "Suchen",
  "status": "Status",
  "firmware": {
    "range": "Gerätetypen"
  },
  "connectivityState": {
    "active": "Verbunden",
    "inactive": "Inaktiv"
  }
}
